import "./styles.less"
import dayjs from "dayjs"
import { useEffect } from "react"
import {
  Button, Card, Form, Message, Segment
} from "semantic-ui-react"
import { usePautas } from "../../hooks/usePautas"
import TextEditor from "../../components/TextEditor"
import { useStore } from "../../stores/useStoreProfile"

interface FormPautasProps {
  idPauta: string;
  visualizar: boolean;
}

export function FormPautas({ idPauta, visualizar }: FormPautasProps) {
  const { store, success, api } = usePautas()
  const { store: profile, dominios } = useStore()

  const { add_pauta } = profile.permissions
  const areasRelatoras = add_pauta
    .filter((e) => e.area_relatora)
    .map((e) => +e.area_relatora)

  useEffect(() => {
    if (idPauta) {
      api.get(idPauta)
    }
  }, []) // eslint-disable-line

  const departamentoOptions = dominios.departamento.map((dep) => {
    return {
      value: dep.id,
      text: dep.sigla,
      key: dep.id,
    }
  })

  const disabled = store.publicada || visualizar

  return (
    <Card fluid className="card-form">
      <Card.Content>
        <Form
          className="formPautas"
          error={Boolean(api.checkError("detail"))}
          success={Boolean(success)}
        >
          <Message
            icon="times circle outline"
            error
            header={api.checkError("detail")}
          />
          <Message icon="check circle outline" success header={success} />
          <Form.Group widths="equal">
            <Form.Select
              name="pauta-area-relatora"
              required
              fluid
              label="Área Relatora"
              value={store.area_relatora}
              options={departamentoOptions.filter((dep) =>
                areasRelatoras.includes(dep.value)
              )}
              placeholder="Selecione"
              onChange={(e, { value }) => {
                api.setStore({ area_relatora: value, departamento: null })
              }}
              width={2}
              error={api.checkError("area_relatora")}
              disabled={disabled}
            />

            <Form.Select
              required
              fluid
              name="pauta-monitoramento"
              label="Nível de Monitoramento"
              value={store.departamento}
              options={departamentoOptions.filter((e) =>
                add_pauta.filter(e =>
                  +e.area_relatora === store.area_relatora
                ).map(e => +e.departamento).includes(e.value)
              )}
              placeholder="Selecione"
              onChange={(e, { value }) => {
                api.setStore({ departamento: value })
              }}
              width={2}
              error={api.checkError("departamento")}
              disabled={disabled}
            />

            <Form.Input
              fluid
              label="DATA"
              disabled
              type="text"
              value={dayjs(store.data).format("L")}
              width={2}
            />

            {store.id && (
              <Form.Input
                name="pauta-responsavel"
                fluid
                label="Responsável"
                disabled
                type="text"
                value={store.responsavel}
                width={10}
              />
            )}
          </Form.Group>

          <Form.Group widths="equal">
            <Form.Input
              name="pauta-titulo"
              required
              label="Título"
              value={store.titulo}
              onChange={(e, { value }) => { api.setStore({ titulo: value }) }}
              disabled={disabled}
              error={api.checkError("titulo")}
              style={{minHeight: '1rem', overflow:'show'}}
            />
          </Form.Group>

          <Form.Field
            name="pauta-texto"
            required
            control={TextEditor}
            label="Descrição"
            value={store.descricao}
            onChange={(e: string) => {
              api.setStore({ descricao: e })
            }}
            disabled={disabled}
            error={api.checkError("descricao")}
          />
        </Form>
        <Segment basic clearing className={"actions-button"}>
          <Button onClick={() => window.history.back()}>Cancelar/Fechar</Button>
          {!visualizar
            ? store.publicada
              ? <Button
                name="pauta-remover-publicar"
                onClick={() => api.removerPublicacao()}
                floated="right"
                disabled={api.checkLoading("removerPublicacao")}
              >
                Remover Publicação
              </Button>
              : <>
                <Button
                  name="pauta-salvar-publicar"
                  onClick={() => api.publicar()}
                  floated="right"
                  disabled={api.checkLoading("publicar")}
                >
                  Salvar e Publicar
                </Button>
                <Button
                  name="pauta-salvar"
                  onClick={() => api.save()}
                  floated="right"
                  disabled={api.checkLoading("save")}
                >
                  Salvar
                </Button>
              </>
            : null
          }
        </Segment>
      </Card.Content>
    </Card>
  )
}
